import { Link } from "react-router-dom";
import { Copy, CopyPlus, Trash2, BookOpen, BarChart3 } from "lucide-react";
import { toast } from "sonner";

export const joinUrl = (code) => `${window.location.origin}/t/${code}`;

export const copyJoin = async (code) => {
  try {
    await navigator.clipboard.writeText(joinUrl(code));
    toast.success("Join link copied");
  } catch {
    toast.message(joinUrl(code));
  }
};

export const copyStaff = async (code) => {
  const url = `${window.location.origin}/c/${code}`;
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Coach link copied. Share it only with your coaches.");
  } catch {
    toast.message(url);
  }
};

export const TeamCard = ({ team, levelName, onDuplicate, onDelete }) => (
  <div className="card space-y-4" data-testid={`team-card-${team.id}`}>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <h3 className="font-heading text-2xl font-extrabold uppercase leading-tight truncate" data-testid="team-card-name">{team.name}</h3>
        <p className="text-sm font-semibold text-[var(--muted)]">
          {team.sport === "baseball" ? "Baseball" : "Softball"} · {levelName}{team.season ? ` · ${team.season}` : ""}
        </p>
      </div>
      <span className="badge-coach" data-testid="team-card-custom-count">{team.custom_count} custom</span>
    </div>
    <div className="join-box">
      <div>
        <span className="ctl-label">Join code</span>
        <div className="font-mono text-2xl font-bold tracking-[0.2em]" data-testid="team-join-code">{team.join_code}</div>
      </div>
      <button className="btn-ghost !min-h-[44px]" data-testid="copy-join-link-button" onClick={() => copyJoin(team.join_code)}><Copy size={18} /> Copy link</button>
    </div>
    <div className="flex flex-wrap gap-2">
      <Link to={`/coach/teams/${team.id}`} className="btn-primary flex-1" data-testid="open-playbook-button"><BookOpen size={18} /> Open playbook</Link>
      <Link to={`/coach/teams/${team.id}/practice`} className="btn-ghost" data-testid="practice-stats-button"><BarChart3 size={18} /> Practice</Link>
      <button className="btn-ghost" data-testid="duplicate-team-button" onClick={onDuplicate}><CopyPlus size={18} /> Duplicate</button>
      <button className="btn-ghost !px-3" data-testid="delete-team-button" onClick={onDelete} aria-label="Delete team"><Trash2 size={18} /></button>
    </div>
  </div>
);
